/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRouteCreateMutation($customerAccountId: ID!, $type: CUSTOMER_TYPE!, $displayName: String!) {
  SenderRouteCreate(customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
